/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { BuilderUserContext } from '@gh/builder-shared';
import { ApplicationView, OfficeRestService } from '@gh/builder-shared-data';
import { InitViewService } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { SlicedDataSource } from '@gh/core-data';
import { GridLayoutService } from '@gh/core-ui-grid';
import { Observable } from 'rxjs';
import { OfficeListItem } from './office-list-item.model';

@Injectable()
export class OfficeListBusinessService implements InitViewService {
  constructor(public restService: OfficeRestService,
              private gridLayoutService: GridLayoutService,
              private userContext: BuilderUserContext) {
  }

  initView(): any {
    return {
      gridLayout: this.userContext.applicationView === ApplicationView.Corporate ? this.gridLayoutService.get(
        'officesCorporateView') : this.gridLayoutService.get('officesMasterView'),
    };
  }

  findAllAsDataSource(filter?: any): SlicedDataSource<OfficeListItem> {
    return this.restService.findAllAsDataSource(filter);
  }

  deactivate(office: OfficeListItem, force: boolean = false): Observable<OfficeListItem> {
    return this.restService.deactivate(office, force);
  }

  delete(office: OfficeListItem): Observable<OfficeListItem> {
    return this.restService.delete(office);
  }

  checkUsers(id: ID): Observable<any> {
    return this.restService.checkUsers(id);
  }

  validate(id: ID): Observable<any> {
    return this.restService.validate(id);
  }
}
